import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/pricingRules', request)
}

export {get}
